import styled from 'styled-components';

import { Menu as MenuComponent } from '@pearsontechnology/aero-components';

export const Menu = styled(MenuComponent)`
  margin-top: 10px;
  word-break: normal;
`;

export const MenuListItemText = styled.div`
  margin: 0 8px;
`;
